// extracted by mini-css-extract-plugin
export default {"loading":"PostCommentInput_loading__k3Dt4","noBorder":"PostCommentInput_noBorder__E9j+o","submitButton":"PostCommentInput_submitButton__MvjfP"};